import axios from 'axios';

const axiosConfig = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/api',
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor - SADECE TOKEN EKLEME
axiosConfig.interceptors.request.use(
  (config) => {
    // Clear any existing authorization header first
    delete config.headers.Authorization;
    
    // Check URL to determine expected token type
    const isAdminRoute = config.url?.includes('/admin/');
    const isStudentRoute = config.url?.includes('/ogrenci/');
    const isTeacherRoute = config.url?.includes('/ogretmen/');
    
    // Priority based token selection for better cache handling
    if (isAdminRoute) {
      const adminToken = localStorage.getItem('token') || localStorage.getItem('authToken');
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
    } else if (isStudentRoute || config.url?.includes('/student/')) {
      const studentToken = localStorage.getItem('studentToken');
      if (studentToken) {
        config.headers.Authorization = `Bearer ${studentToken}`;
      }
    } else if (isTeacherRoute || config.url?.includes('/teacher/')) {
      const teacherToken = localStorage.getItem('teacherToken');
      if (teacherToken) {
        config.headers.Authorization = `Bearer ${teacherToken}`;
      }
    } else {
      // Fallback for unclear routes - try admin first, then others
      const adminToken = localStorage.getItem('token') || localStorage.getItem('authToken');
      const studentToken = localStorage.getItem('studentToken');
      const teacherToken = localStorage.getItem('teacherToken');
      
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      } else if (studentToken) {
        config.headers.Authorization = `Bearer ${studentToken}`;
      } else if (teacherToken) {
        config.headers.Authorization = `Bearer ${teacherToken}`;
      }
    }
    
    // Transitional config'i kaldır
    delete config.transitional;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - 401/403 hatalarını yakala
axiosConfig.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 veya 403 hatası alındığında token'ları temizle ve login sayfasına yönlendir
    if (error.response?.status === 401 || error.response?.status === 403) {
      // URL'den role'ü belirle
      const currentPath = window.location.pathname;
      
      // Login endpoint'ine yapılan istekleri yönlendirme
      if (error.config?.url?.includes('/login')) {
        return Promise.reject(error);
      }
      
      if (currentPath.includes('/student')) {
        localStorage.removeItem('studentToken');
        window.location.href = '/student/login';
      } else if (currentPath.includes('/teacher')) {
        localStorage.removeItem('teacherToken');
        window.location.href = '/teacher/login';
      } else if (currentPath.includes('/admin')) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        window.location.href = '/admin/login';
      }
    }
    
    return Promise.reject(error);
  }
);

export default axiosConfig;